// extracted by mini-css-extract-plugin
export var dropdown = "_fx-0";
export var imagePlaceholder = "_fx-2";
export var imageWrapper = "_fx-3";
export var productImage = "_fx-1";
export var truncateContainer = "_fx-4";
export var truncateText = "_fx-5";